const Create = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CashierReports/Create')
const Print = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CashierReports/Print')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/CashierReports/Search')

export default [
  {
    path: 'cashier-reports/create',
    name: 'CashierReportsCreate',
    component: Create,
    meta: {
      title: 'Adicionar Relatório de Caixa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cashierReports',
        action: 'create'
      }
    }
  },
  {
    path: 'cashier-reports/:id/print',
    name: 'CashierReportsPrint',
    component: Print,
    meta: {
      title: 'Imprimir Relatório de Caixa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cashierReports',
        action: 'read'
      }
    }
  },
  {
    path: 'cashier-reports',
    name: 'CashierReportsSearch',
    component: Search,
    meta: {
      title: 'Relatórios de Caixa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'cashierReports',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/cashier-reports.js